export const SchedulesEndpoints = {
	schedules: '/schedules'
} as const
